import load_icon from "assets/svgIcon/loading-icon.svg";
const LoadMoreButton = ({ loadMore }) => {
    return (
        <button className="nexogic_primary_button loading-btn btn btn-secondary" onClick={loadMore}>
           <img src={load_icon} alt="load_icon" className="icon" /> Load More
        </button>
    )
}

export default LoadMoreButton;